import React, { Component } from 'react'
import { NewButton } from '../shared/NewButton'
import { Image } from '../Products/image'
import '../stylesheets/reservations/index.sass'
import noInventory from '../images/NoInventory.png'

export default class NoReservations extends Component {

    render() {
      return (
        <div className={'welcome-wrapper row'}>
          <div className={'column one'}>
            &nbsp;
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className={'column two reservation-welcome'}>
            <Image
              image_url={ noInventory }
              imageClass='product-update-image'
              height='120'
              width='100'
            />
            <div style={{ marginTop: 30, fontSize: 18, fontWeight: 400, color: '#A0A0A0' }} className={'row'}>
              No inventory yet
            </div>
            <div style={{ color: '#4D4D4D' }} className={'row'}>
        When you scan full kegs in they will appear on the “Available Inventory” page.
            </div>
            <div style={{ color: '#4D4D4D' }} className={'row'}>
              Update “Future Inventory” manually to show visitors what you’ll have available for reservation in the next two weeks.
            </div>
          </div>
          <div className={'column three'}>
            &nbsp;
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Inventory/NoInventory.js